import React, { useState } from 'react';
import BottomSheet from '../components/BottomSheet/BottomSheet';
import Typography from '../components/Text/Typography';
import Button from '../components/Button/Button';
import TextInput from '../components/Text/TextInput';
import './ContactUsBottomSheet.css';

interface ContactUsBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSend?: (message: string) => void;
}

const ContactUsBottomSheet: React.FC<ContactUsBottomSheetProps> = ({ 
  isOpen, 
  onClose, 
  onSend 
}) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      // Create mailto link with pre-filled email
      const subject = encodeURIComponent('User feedback/comment');
      const body = encodeURIComponent(message);
      const mailtoLink = `mailto:dew.don.lee@gmail.com?subject=${subject}&body=${body}`;
      
      // Open default email client
      window.open(mailtoLink, '_blank');
      
      // Call the onSend callback if provided
      if (onSend) onSend(message);
      
      // Clear the message and close bottom sheet
      setMessage('');
      onClose();
    }
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      title="Contact Us"
      height="60vh"
      className="contact-us-bottom-sheet"
    >
      <div className="contact-us-content">
        <div className="message-section">
          <Typography variant="body-bold" className="message-label">
            Your Message
          </Typography>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Write your message here..."
            className="message-textarea"
            rows={6}
          />
        </div>
        
        <div className="helper-text">
          <Typography variant="body-small" className="helper-text-content">
            Clicking "Send" will open your default email client with a pre-filled message.
          </Typography>
        </div>
      </div>

      <div className="contact-us-footer">
        <Button
          variant="primary"
          onClick={handleSend}
          disabled={!message.trim()}
          className="send-button"
        >
          Send Message
        </Button>
      </div>
    </BottomSheet>
  );
};

export default ContactUsBottomSheet;
